import "instant.page";
import SkipLinks from "./modules/SkipLinks";
import MenuMobile from "./modules/MenuMobile";
import MenuDesktop from "./modules/MenuDesktop";
import SliderBlock from "./blocks/SliderBlock";
import CategoryIconsBarBlock from "./blocks/CategoryIconsBarBlock";
import WhyUsBlock from "./blocks/WhyUsBlock";
import TestimonialsBlock from "./blocks/TestimonialsBlock";
import ProductGallery from "./modules/ProductGallery";
import ProductFunctions from "./modules/ProductFunctions";
import AddToCart from "./modules/AddToCart";
import Modal from "./modules/Modal";
import ProductReviews from "./modules/ProductReviews";
import Wishlist from "./modules/Wishlist";
import ProductList from "./modules/ProductList";
import Dropdown from "./modules/Dropdown";
import BillingFields from "./modules/BillingFields";
import QuantityButtons from "./modules/QuantityButtons";
import Checkout from "./modules/Checkout";
import GetProductsByAttr from "./modules/GetProductsByAttr";
import DropdownMobile from "./modules/DropdownMobile";
import Search from "./modules/Search";
import AnimateOnScroll from "./modules/AnimateOnScroll";

document.addEventListener("DOMContentLoaded", () => {
	const skipLinks = new SkipLinks();
	const menuMobile = new MenuMobile();
	const menuDesktop = new MenuDesktop();

	//blocks
	const sliderBlock = new SliderBlock();
	const categoryIconsBarBlock = new CategoryIconsBarBlock();
	const whyUsBlock = new WhyUsBlock();
	const testimonialsBlock = new TestimonialsBlock();

	const modal = new Modal();

	//woo
	const productGallery = new ProductGallery();
	const productFuncitons = new ProductFunctions();
	const productList = new ProductList();
	const addToCart = new AddToCart();
	const productReviews = new ProductReviews();
	const wishlist = new Wishlist();
	const quantityButtons = new QuantityButtons();
	const billingFields = new BillingFields();
	const checkout = new Checkout();
	const getProductsByAttr = new GetProductsByAttr();
	const search = new Search();

	const dropdown = new Dropdown();
	const dropdownMobile = new DropdownMobile();

	const animateOnScroll = new AnimateOnScroll();
});
